module.exports = __webpack_public_path__ + "img/view-open.1052f935.svg";